import { isFeatureEnabled } from 'owa-feature-flags';

export default function isCalendarCardEnabled(): boolean {
    return isExpandingCalendarCardEnabled() || isTabbedCalendarCardEnabled();
}

export function isExpandingCalendarCardEnabled(): boolean {
    return (
        isFeatureEnabled('cal-mf-mailCalendarCard-expand') ||
        isFeatureEnabled('cal-mf-mailCalendarCard-expand-exp')
    );
}

export function isTabbedCalendarCardEnabled(): boolean {
    return (
        isFeatureEnabled('cal-mf-mailCalendarCard-tabbed') ||
        isFeatureEnabled('cal-mf-mailCalendarCard-tabbed-exp')
    );
}
